import axios from "./axios";
import language from "./language";

interface Areacode {
    country: string;
    code: string;
    image: string;
    created_at: string;
    updated_at: string;
}

export default async function (): Promise<Areacode[]> {
    const { data } = await axios.get("general/areacode/list", {
        params: {
            lang: language()
        }
    });

    if (data.message == "OK") {
        return data.data;
    }

    return [];
}
